export default "__VITE_ASSET__BPcsllJ2__"